//Analytics team has asked for removal of spaces, underscores,
//and set to lowercase in some situations
export const sanatizeInput = (input: string | undefined) => input?.toLowerCase().replace(/[_\s]/g, '') ?? '';
